import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const inboxChannel = defineChannel({
  id: 'inbox',
  icon: 'notifications',
} as const satisfies ChannelDefinition);
